import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import './ContentSection.scss';
import { ModuleStatus } from 'types/module';

type Props = {
  status: ModuleStatus;
  title: string;
  description: string;
  numberOfChapters: number;
  numberOfTests: number;
  numberOfCertifications: number;
  isAdmin?: boolean;
};

export const ContentSection = ({
  status,
  title,
  description,
  numberOfChapters,
  numberOfTests,
  numberOfCertifications,
  isAdmin,
  children,
}: PropsWithChildren<Props>) => {
  const { t } = useTranslation();

  const chapters =
    numberOfChapters === 1
      ? t('SingleChapter', { ns: 'learningHub' })
      : t('NumberOfChapters', { chapters: numberOfChapters, ns: 'learningHub' });
  const tests =
    numberOfTests === 1 ? t('SingleTest', { ns: 'learningHub' }) : t('NumberOfTests', { tests: numberOfTests, ns: 'learningHub' });
  const certifications =
    numberOfCertifications === 1
      ? t('SingleCertification', { ns: 'learningHub' })
      : t('NumberOfCertifications', { certifications: numberOfCertifications, ns: 'learningHub' });

  return (
    <div className='module-content'>
      <div className='progress-bar-container'>{children}</div>
      <div className='module-title-section'>
        <span className={`${status === 'ComingSoon' && !isAdmin ? 'module-title-coming-soon' : 'module-title'}`}>{title}</span>
      </div>

      <p className='module-description'>{description}</p>

      <div className='module-divider' />
      <div className='module-tags'>
        <div className='chip'>
          <span className='chip-text'>{chapters}</span>
        </div>
        <div className='chip'>
          <span className='chip-text'>{tests}</span>
        </div>
        <div className='chip'>
          <span className='chip-text'>{certifications}</span>
        </div>
      </div>
    </div>
  );
};
